import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

export const icon = css`
  fill: #828b99;
`

export const tooltipContainer = (theme: Theme) => css`
  position: relative;

  &:hover {
    cursor: pointer;

    .content {
      visibility: visible;
      opacity: 1;
      transition: 0.5s opacity;
    }

    svg {
      fill: ${theme.palette.primary.maxContrast};
    }
  }
`

export const tooltipContent = (theme: Theme) => css`
  visibility: hidden;
  opacity: 0;
  transition: 0.5s opacity;
  background-color: ${theme.palette.background.main};
  box-shadow: ${theme.shadows.demoBox};
  border-radius: 6px;
  position: absolute;
  top: -1.1em;
  left: 50%;
  padding: 1.5em;
  min-width: 28em;
  z-index: 2;
  font-size: 1rem;
  text-align: left;
  transform: translate(-50%, -100%);

  &::after {
    position: absolute;
    content: '';
    bottom: -0.75em;
    left: 0;
    right: 0;
    margin: auto;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 1em 1.75em 0 1.75em;
    border-color: ${theme.palette.background.main} transparent transparent
      transparent;
  }
`
